import Modal from '../../../Components/Shared/Modal/Modal';
import { useState } from 'react';
import styles from './EditWarehouse.module.css';
import axiosInstance from '../../../Configuration/axiosInstance';
import LoadingSpinner from '../../../Components/Shared/Loader/Loader';
const EditWarehouse = ({
  show,
  selectedWarehouse,
  setShow,
  dataChanged,
  setDataChanged,
}) => {
  const [payload, setPayLoad] = useState();
  const [loading, setLoading] = useState(false);
  const handleUpdate = () => {
    console.log(payload);
    setLoading(true);
    axiosInstance
      .patch(`warehouse/${selectedWarehouse._id}`, payload)
      .then((res) => {
        setLoading(false);
        setDataChanged((prevValues) => !prevValues);
        setShow(!show);
      });
  };
  const handleInput = (e) => {
    const { name, value } = e.target;
    setPayLoad((prevValues) => ({ ...prevValues, [name]: value }));
  };
  return (
    <Modal show={show}>
      
        {loading ? <LoadingSpinner/> :  <div style={{ padding: '20px' }}> <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <h1>Edit Warehouse Data</h1>
          <div
            className={styles.crossBtn}
            onClick={() => {
              setShow(!show);
              setDataChanged(!dataChanged);
            }}
          >
            &times;
          </div>
        </div>
        <table>
          <thead>
            <th>Name</th>
            <th>Location</th>
            <th>Type</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <input
                  type='text'
                  name='name'
                  onChange={handleInput}
                  defaultValue={selectedWarehouse.name}
                />
              </td>
              <td>
                <input
                  type='text'
                  name='location'
                  onChange={handleInput}
                  defaultValue={selectedWarehouse.location}
                />
              </td>
              <td>
                <select name='warehousetype' onChange={handleInput}>
                  <option disabled>Select an Option</option>
                  <option>Primary</option>
                  <option>Secondary</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
        <button onClick={() => handleUpdate()}>Update</button>
      </div> }

      
    </Modal>
  );
};
export default EditWarehouse;
